import React from 'react';
import { IconButton } from '../Button';
import styled from 'styled-components';
import { IconButtonContentStyles } from '../Button/Iconbutton';
import { COLORS } from '../styles';

const Wrapper = styled.div`
  ${IconButtonContentStyles} {
    transition: all 0.1s ease-in-out;
  }

  &.disabled,
  &.active:not(.state-change) {
    ${IconButtonContentStyles} {
      background: ${COLORS.white};
    }
  }

  &.active:not(.state-change) {
    ${IconButtonContentStyles}:after {
      content: '';
      position: absolute;
      left: 12px;
      bottom: 1px;
      background-color: ${COLORS.primary_500};
      border-radius: 4px;
      height: 4px;
      width: 24px;
    }
  }

  &.disabled:not(.state-change) {
    ${IconButtonContentStyles}:after {
      background: ${COLORS.neutral_300};
    }
  }
`;

export interface ToggleButtonState {
  icon: React.ReactNode;
  color?: string;
}

export interface ToggleButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'disabled' | 'onClick'> {
  active: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;

  defaultState: ToggleButtonState;
  activeState?: ToggleButtonState;
}

export const ToggleButton = React.forwardRef(({
                                                id,
                                                active,
                                                onChange,
                                                disabled,
                                                defaultState,
                                                activeState,
                                                className,
                                                ...rest
                                              }: ToggleButtonProps, ref: React.Ref<HTMLButtonElement>) => {
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => setIsActive(active), [active]);

  const cls = `${className || ''} ${isActive ? 'active' : ''} ${activeState ? 'state-change' : ''} ${disabled ? 'disabled' : ''}`;

  return (
    <Wrapper className={cls}>
      <IconButton
        variant={'secondary'}
        ref={ref}
        useTransparentBackground={true}
        shape={'circular'}
        action={() => {
          setIsActive(!isActive);
          if (onChange) {
            onChange(!isActive);
          }
        }}
        id={id}
        iconColor={isActive ? activeState?.color ?? defaultState.color : defaultState.color}
        disabled={disabled}
        aria-pressed={isActive}
        {...rest}>
        {isActive ? activeState?.icon ?? defaultState.icon : defaultState.icon}
      </IconButton>
    </Wrapper>
  );
});

export default ToggleButton;
